import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store' // 🔴 添加这一行引入 store

// 导入组件
import Login from '../views/Login.vue'
import AIChat from '@/views/AIChat.vue' //AI对话
import Recharge from '@/views/Recharge.vue' //充值页面

Vue.use(VueRouter)

const routes = [{
		path: '/',
		name: 'Login',
		component: Login
	},

	{
		path: '/index',
		name: 'GraphView',
		component: () => import('@/views/GraphView.vue'),
		meta: {
			title: '图谱视图',
			requiresAuth: true // 🔐 AI聊天也需要登录
		}
	},
	{
		path: '/knowled-management',
		name: 'KnowledgeManagement',
		component: () => import('@/views/KnowledgeManagement.vue'),
		meta: {
			title: '知识管理',
			requiresAuth: true // 🔐 AI聊天也需要登录
		}
	},
	{
		path: '/graph-management',
		name: 'GraphManagement',
		component: () => import('@/views/GraphManagement.vue'),
		meta: {
			title: '图谱管理',
			requiresAuth: true // 🔐 AI聊天也需要登录
		}
	},
	// {
	// 	path: '/recharge',
	// 	name: 'Recharge',
	// 	component: Recharge,
	// 	meta: {
	// 		title: '充值中心',
	// 		requiresAuth: true // 🔐 充值中心也需要登录
	// 	}
	// },
	
	// // 404 页面
	// {
	//   path: '*',
	//   name: 'NotFound',
	//   component: () => import('@/views/NotFound.vue'),
	//   meta: {
	//     title: '页面未找到'
	//   }
	// }
]

const router = new VueRouter({
	mode: 'history', // 使用 history 模式，去掉 URL 中的 #
	base: process.env.BASE_URL,
	routes,
	// 页面滚动行为
	scrollBehavior(to, from, savedPosition) {
		if (savedPosition) {
			return savedPosition
		} else {
			return {
				x: 0,
				y: 0
			}
		}
	}
})

// 🔒 路由守卫 - 登录验证和页面标题设置
router.beforeEach((to, from, next) => {
	// 设置页面标题
	if (to.meta.title) {
		document.title = `${to.meta.title} - 智能备课系统`
	}

	// 检查是否需要登录验证
	if (to.matched.some(record => record.meta.requiresAuth)) {
		// 检查用户是否已登录
		const isLoggedIn = checkUserAuth()

		if (!isLoggedIn) {
			// 未登录，重定向到登录页面
			next({
				path: '/',
				query: {
					redirect: to.fullPath // 保存原来要访问的路径，登录后可以重定向回来
				}
			})
		} else {
			// 已登录，继续访问
			next()
		}
	} else {
		// 不需要登录验证的页面，直接访问
		next()
	}
})

// 🔍 检查用户登录状态的函数
function checkUserAuth() {
	const sessionUser = sessionStorage.getItem('currentUser')

	if (sessionUser) {
		try {
			const userData = JSON.parse(sessionUser)

			// 如果store中没有用户数据，同步更新（防止刷新页面后store丢失）
			if (!store.getters.currentUser) {
				store.commit('SET_USER', userData)
			}

			return true
		} catch (error) {
			console.error('解析用户数据失败:', error)
			sessionStorage.removeItem('currentUser')
			return false
		}
	}

	return false
}

export default router